import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Mockable } from '../../mocks/mockable.decorator';

export enum Theme {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Light,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Dark
}

@Injectable({
    providedIn: 'root'
})
@Mockable
export class ThemeService {

    private readonly subject = new BehaviorSubject<Theme>(Theme.Light);

    // eslint-disable-next-line @typescript-eslint/member-ordering,no-invalid-this
    public themeChanges = this.subject.asObservable();

    public theme(): Theme {
        return this.subject.value;
    }

    public setLightTheme() {
        this.subject.next(Theme.Light);
    }

    public setDarkTheme() {
        this.subject.next(Theme.Dark);
    }

}
